<template>
	<div class="chart">
		<BaseChart :option="baseOption" />
	</div>
</template>

<script>
	export default {
		name: 'ClueSources',
		props: {
			xData: {
				type: Array,
				default: () => [],
			},
			barData: {
				type: Array,
				default: () => [],
			},
		},
		computed: {
			baseOption() {
				return {
					grid: {
						bottom: '20%',
						right: '5%',
						top: '5%',
						left: '5%',
					},
					tooltip: {
						trigger: 'axis',
					},
					legend: {
						data: ['成交率', '线索数量', '成交数量'],
						bottom: '2%',
						itemWidth: 14,
						itemGap: 60,
					},
					xAxis: [
						{
							type: 'category',
							data: ['自然来访', '公众号推文', '中介渠道', '客户满推'],
							splitLine: {
								show: true,
								lineStyle: { type: 'dashed' },
							},
						},
					],
					yAxis: [
						{
							type: 'value',
							max: 350,
							splitLine: {
								lineStyle: { type: 'dashed' },
							},
						},
						{
							type: 'value',
							splitLine: {
								lineStyle: { type: 'dashed' },
							},
						},
					],
					series: [
						{
							name: '成交率',
							type: 'line',
							yAxisIndex: 1,
							color: '#FB923C',
							data: [320, 302, 301, 334],
						},
						{
							name: '线索数量',
							type: 'bar',
							barWidth: '15%',
							color: '#4080FF',
							data: [120, 132, 101, 134],
						},
						{
							name: '成交数量',
							type: 'bar',
							barWidth: '15%',
							color: '#16A34A',
							data: [220, 182, 191, 234],
						},
					],
				};
			},
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.chart {
		width: 100%;
		height: 100%;
	}
</style>
